export class Sample{
    _id: string = "";
    sampleID: string = "";
    parentSampleID:string;
    barCode: string = "";
    bottomBarcode = "";
    position: string = "";
    sampleType: string = "";
    beadChipID: string = "";
    beadChipPosition: string = "";
    gender: string = "";
    color: string = "";
    boxID: string = "";
    boxReceptionTimeStamp!: Date;
    sourcePlateID: string = "";
    sourcePlatePosition: string = "";
    projectID: string = "";
    projectName?:string = "";
    selectedSampleType = "";
    reProcessed: boolean = false;
    priority: number = 10;
    reRunCount: number = 0;
    autoRerun: boolean = false;
    icbfSampleID: number = 0;
    plateRedo: boolean = false;
    singleRedo: boolean = false;
    dueDate?:Date;
    qcSampleHistory: Array<string> = [];
    plateDueDate?:Date;
    receptionStatus?: string;
    receptionIssueReason?:string;
    storage?:boolean;
    activated: boolean;
    announced: boolean;
    receptionPUID: string;
    plateHistory: any;
    assignedSampleType: any;
    sampleCompletionDate!:Date;
    workFlow = "";
    workflowID = "";
    animalNumber:string;
    ittNumber:string;
    isRedoSample: boolean;
    multipleWorkflows = false;
    mintSampleID: string;
    parentMintSampleID:string;
    parentBarcode:string;
    additionalFields:any;
    childSamples:Array<{index:number,workflowID:string}> = [];
    lastUpdatedPlateFieldName = "";
    lastUpdatedPlateFieldValue = "";
    plated = false;
}
